export default __webpack_public_path__ + "static/media/Path 20551blue.d5d2eed2.svg";